import { defineStore } from 'pinia'
import actions from './actions'
import mutations from './mutations'

export const useMatchDetailStore = defineStore('matchDetail', {
  state: () => ({
    eventId: '',
    event: {},
    currentTab: 'Market',
    marketGroupList: [],
    liveMatches: {},
    // 所有收藏的 market id list
    favouriteMarketIds: [],
    // 当前是否在 commentary
    isCommentary: false,
    // 信息流历史消息列表
    liveCommentaryList: [],
    // 直播状态 1正常 2暂停
    liveCommentaryStatus: '',
    // 广告角标
    liveCommentaryHasVouvher: false,
    liveRemainCount: '',
    // 分割线位置
    dividerIndex: -1,
    // 上一条commentary的id
    lastCommentaryId: '',
    // 推送自建消息池子
    commentaryMessagePool: [],
    // 暂停2s自建消息推送，重新计时
    restartMessageShow: false,
    // 正在请求的 commentary marekt id map
    reqMarketIdsMap: {},
    // 已经订阅的 market id
    subedMarketIds: {},
    // 当前底部显示的消息类型
    currentFixedType: 0,
    currentFixedId: '',
    // 历史消息是否还有更多
    HistoryNoMore: false,
    // 推送开关
    commentarySubStatus: localStorage.getItem('live_commentary_update') !== 'false',
    // 推送开关
    commentaryAnimStatus: localStorage.getItem('live_commentary_anime') !== 'false',
    // 推送开关
    commentaryBotStatus: localStorage.getItem('live_commentary_bottom') !== 'false',
    subscribedIgpomsTopicSet: new Set()
  }),
  actions: {
    ...actions,
    ...mutations
  }
})
